import FormField from '../swedish-private-v2/form-field';
import InputPersonalId from '../swedish-private-v2/input-personal-id';
import PersonalDetailsAutoFill from '../swedish-private-v2/personal-details-autofill';
import Terms from '../swedish-private-v2/terms';
import { Marketing } from '../swedish-private-v2/marketing';
import { Heading } from '../../common/form/form-parts';
import { AutoFilledPersonalDetails } from './auto-filled-personal-details';
import { ManualPersonalDetails } from './manual-personal-details';
import { Button } from 'tradera/components/atoms/button/button';
import { FormFooterLogo } from 'tradera/apps/registration/components/common/form/form-footer-logo';
import { AliasSuggestions } from '../../common/alias-suggestions';

export const SwedishPrivateKlarna = (props) => {
    const {
        form,
        onNavigate,
        onChangeAcceptsTerms,
        acceptsTerms,
        isNativeAppContext,
        termsError
    } = props;
    const autoFilled =
        !form.autoFillFailed &&
        !form.hasAnyFieldSetFromUserInput(
            PersonalDetailsAutoFill.manuallyFilledFields
        );
    const firstName = form.get('KlarnaFirstName') || form.get('FirstName');
    const addressValid = form.isValid(PersonalDetailsAutoFill.autoFilledFields);
    const showAutoFilledPersonalDetails =
        autoFilled && addressValid && form.isValid(['PersonalNumber']);
    const showManualPersonalDetails =
        (!autoFilled || !addressValid) && form.isValid(['PersonalNumber']);
    return (
        <>
            <div />
            <div className={'mt-7'}>
                <Heading>{firstName ? `Hej ${firstName}!` : `Hej!`}</Heading>
                <h4 className="font-weight-bold">
                    Nu behöver du bara komplettera din profil med följande info:
                </h4>
                <FormField
                    containerClassName="mb-2"
                    form={form}
                    field="Alias"
                    placeholder="Välj ditt användarnamn på Tradera"
                    hint="Ditt användarnamn visas för andra när du lägger bud, köper eller säljer på Tradera."
                />
                <AliasSuggestions
                    alias={form.get('Alias')}
                    email={form.get('EmailAddress')}
                    firstName={form.get('FirstName')}
                    lastName={form.get('LastName')}
                    onSelect={(alias) => form.setFromUserInput('Alias', alias)}
                />
                <FormField
                    containerClassName="mb-2"
                    form={form}
                    field="PersonalNumber"
                    inputComponent={InputPersonalId}
                    placeholder="Personnummer (ÅÅMMDDNNNN)"
                    hint="Syftet med att lämna personnummer är att öka din säkerhet då ingen är anonym när man gör affärer på Tradera. Dina personuppgifter lagras i en skyddad miljö och lämnas aldrig ut till obehöriga."
                />
                {showAutoFilledPersonalDetails && (
                    <AutoFilledPersonalDetails form={form} />
                )}
                {showManualPersonalDetails && (
                    <ManualPersonalDetails form={form} />
                )}
                <Terms
                    onChange={onChangeAcceptsTerms}
                    accepts={acceptsTerms}
                    termsError={termsError}
                />
                <Marketing />
                <Button
                    theme="primary"
                    fluid
                    className="my-3"
                    id="navigate_next"
                    disabled={!acceptsTerms || !form.isValid()}
                    onClick={onNavigate}>
                    Registrera
                </Button>
                {!isNativeAppContext && (
                    <div className={'text-center mb-3'}>
                        Har du hamnat fel?{' '}
                        <a href="/">Gå tillbaka till Tradera</a>
                    </div>
                )}
            </div>
            <div className="text-center mb-4">
                <FormFooterLogo />
            </div>
        </>
    );
};
